<template>
  <div class="leaderBoardwinner">
    <div class="leadBoardContent">
      <span class="goBackicon">
        <i class="material-icons" @click="handleBack">close</i>
      </span>
      <div class="leadTophead">
        <div class="headImgbox">
          <img src="../../src/assets/images/leaderboard-logo.png" />
        </div>
        <div class="winTitle">शीर्ष दस विजेता</div>
      </div>
      <!-- <h2>शीर्ष दस विजेता</h2> -->

      <div class="leadInner">
        <div class="leadTitlehead">
          <div class="title title_1">Position</div>
          <div class="title title_2">Name</div>
          <div class="title title_3">Duration Time</div>
          <div class="title title_4">Score</div>
        </div>
        <leaderBoardViewport
          :leaderBoardViewportList="leaderBoardViewportList"
          :xAuthIdUser="XAuthID"
          :page="page"
          :DD="DD"
          :MM="MM"
        />
      </div>
    </div>
  </div>
</template>
<script>
import leaderBoardViewport from './leaderBoardViewport'
import LeaderBoardBanner from './LeaderBoardBanner'
import LeaderBoardSelectedList from './LeaderBoardSelectedList'
import { compare } from '../utils/helper'
import { BASE_API_URL, LOCAL_URL } from '../utils/constant'
import * as Cookies from 'js-cookie'
import InfiniteLoading from 'vue-infinite-loading'
import Vue from 'vue'
Vue.use(InfiniteLoading)

export default {
  name: 'leaderBoardWinnerList',
  components: {
    leaderBoardViewport,
    LeaderBoardBanner,
    LeaderBoardSelectedList,
    InfiniteLoading
  },
  data() {
    return {
      leaderBoardViewportList: [],
      DD: new Date().getDate(),
      MM: new Date().getUTCMonth() + 1,
      userData: {},
      page: 1,
      XAuthID: Cookies.get('X-Auth-Id') || null
    }
  },
  methods: {
    handleBack() {
      try {
        JSBridgePlugin.gotToHome()
      } catch (error) {
        console.log('====', error)
        window.location.href = 'https://live.money91.com/#/'
      }
    }
  },
  computed: {},
  mounted() {
    // `${LOCAL_URL}/weekly_and_monthly_leader_board?page_no=1&category=week`
    this.$http
      .get(
        `${LOCAL_URL}/weekly_and_monthly_leader_board?page_no=1&category=month`
      )
      .then(
        function(data) {
          if (data.body) {
            console.log('=--=-=--', data.body.data.data)
            this.userData = data.body.user_data
            this.leaderBoardViewportList = data.body.data.data
          }
        },
        response => {}
      )
  }
}
</script>
<style scoped></style>
